import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { catchError } from "rxjs/operators";
import { Tenant } from "../Models/tenant";

@Injectable({
    providedIn: 'root'
})
export class LanguageService {

    get selectedTenant(): Tenant {
		return this._selectedTenant;
	}
	set selectedTenant(tenant: Tenant) {
		this._selectedTenant = tenant;
	}

	constructor(private http: HttpClient,
		private activatedRoute: ActivatedRoute) {

	}

	private _selectedTenant: Tenant;
    
	private baseUrl = "";

    getLanguages(tenant: Tenant) {
        return this.http.get<any[]>(`${this.baseUrl}/api/airsweblanguage/${tenant.Value}/languages`);
    }

    updateLanguageStatus(tenant: Tenant, enable: string, languageId: string) {
        var queryParams = {
            "LanguageId": languageId.toString(),
            "Enable": enable.toString()
        };

        return this
            .http
            .post<any>(`${this.baseUrl}/api/airsweblanguage/${tenant.Value}/enablelanguage`, queryParams).pipe(catchError((error: any) => {
                return this.handleError(error)
            }));
    }

    updateTranslateStatus(tenant: Tenant, enable: string, languageId: string) {
        var queryParams = {
            "LanguageId": languageId.toString(),
            "Enable": enable.toString()
        };
        return this
            .http
            .post<any[]>(`${this.baseUrl}/api/airsweblanguage/${tenant.Value}/enablegoogletranslate`, queryParams).pipe(catchError((error: any) => {
                return this.handleError(error)
            }));
    }

    private handleError(error: any): Promise<any> {
        console.error("An error occurred", error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}
